<template>
  <res-dialog :title="titleMessage"
              :showDialog="showDialog"
              :maxWidth="maxWidth"
              :setWidth="setWidth"
              :smallTitleIcon="true"
              :cancelButtonOnly="true"
              :cancelButtonTextColor="'primary--text'"
              :cancelButtonColor="'primary'"
              :cancelButtonText="'CLOSE'"
              :cancelButtonWidth="'80'"
              :iconColor="'white'"
              iconTitle="mdi-calendar-blank-multiple"
              :showTitleIcon="false"
              :titleClass="'resBlue darken-1 white--text'"
              @cancel="close">
    <v-card-text>
      <v-row>
        <v-col sm="12">
          The budgets for the below properties <span class="bulk-creation-orange">were not</span> created due to the following errors.
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Property
                  </th>
                  <th class="text-left">
                    Error
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in bulkCreateErrors" :key="i">
                  <td>{{ item.propertyAbbreviation }}</td>
                  <td><span class="bulk-creation-orange">{{ item.error }}</span></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  export default {
    components: {
      ResDialog
    },
    props: {
      showDialog: {
        type: Boolean
      },
      maxWidth: null,
      setWidth: null,
      bulkCreateErrors: {}
    },
    data() {
      return {
        titleMessage: 'Budgets Not Created'
      }
    },
    methods: {
      close() {
        this.$emit('close', true)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    border-top: thin solid rgba(0, 0, 0, 0.12);
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th:last-child {
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }

  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:not(.v-data-table__mobile-row) {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child {
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }

  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child > td {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
  }

  span.bulk-creation-orange {
    color: var(--v-resOrange-darken2);
  }
</style>

